import React from 'react';
import classnames from 'classnames';

const ThSortable = ({
  children,
  order,
  orderBy,
  field,
  handleOrderChange = () => {},
  className,
}) => {
  const handleClick = () => {
    return orderBy === field && order === 'desc'
      ? handleOrderChange(null, null)
      : handleOrderChange(field, field === orderBy ? 'desc' : 'asc');
  };

  return (
    <th onClick={handleClick} className={classnames('th-sortable', className)}>
      <span className="nowrap">
        {children}
        <i
          className={classnames('ml-3 fa', {
            'fa-sort': orderBy !== field,
            'fa-sort-desc': orderBy === field && order === 'desc',
            'fa-sort-asc': orderBy === field && order === 'asc',
          })}
        />
      </span>
    </th>
  );
};

export default ThSortable;



// WEBPACK FOOTER //
// src/modules/common/components/ThSortable.js